export const SET_MODE = 'PT SET MODE';
export const SET_CLUES = 'PT SET CLUES';
export const SET_SKILL = 'PT SET SKILL';
export const SELECT_SIZE = 'PT SELECT SIZE';
export const UPDATE_STATS = 'PT UPDATE STATS';
export const SET_OPTIONS = 'PT SET OPTIONS';
export const SET_OPTION = 'PT SET OPTION';
export const SET_BLOCK = 'PT SET BLOCK';
export const SET_OVER = 'PT SET OVER';
export const SET_OVER_TRUE = { type: SET_OVER, over: true };
export const SET_OVER_FALSE = { type: SET_OVER, over: false };
export const SELECT_TILE = 'PT SELECT TILE';
export const UNSELECT_TILE = { type: SELECT_TILE, selected: null };
export const SET_SCORE = 'PN SET SCORE';
export const SET_TURN = 'PT SET TURN';
export const SET_STARTED = 'PT SET STARTED';
export const SET_STARTED_TRUE = { type: SET_STARTED, started: true };
export const SET_STARTED_FALSE = { type: SET_STARTED, started: false };
export const SET_COLOR_SET = 'PT SET COLOR SET';
